module.exports = __webpack_public_path__ + "static/media/studyProgramImage.b4207247.jpg";